import { load } from "recaptcha-v3";

export default {
  data() {
    return {
      recaptcha: null,
      interval: null
    };
  },
  async mounted() {
    if (!process.env.VUE_APP_RECAPTCHA_KEY) {
      throw new Error(
        "Captcha is not enabled. You have to provide a captcha key"
      );
    }

    await this.loadRecaptcha();
    if (this.recaptcha) {
      this.watchResponse();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async loadRecaptcha() {
      try {
        const recaptcha = await load(process.env.VUE_APP_RECAPTCHA_KEY, {
          explicitRenderParameters: {
            container: "recaptcha"
          }
        });
        this.recaptcha = recaptcha.recaptcha;
      } catch (e) {
        console.error("error loading recaptcha", e);
      }
    },

    watchResponse() {
      this.interval = setInterval(() => {
        if (this.recaptcha) {
          const resp = this.recaptcha.getResponse();

          if (resp) {
            clearInterval(this.interval);
            this.$emit("resolved");
          }
        }
      }, 1000);
    }
  }
};
